module.exports = __webpack_public_path__ + "static/media/logo-sm.66b7c42b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Navs/Footer/Images/logo-sm.png
// module id = 162
// module chunks = 7